module.exports = __webpack_public_path__ + "img/icon-change-phone-success.76396b8b.png";